module.exports = __webpack_public_path__ + "static/media/Hard Flour.b3c249ae.png";